import { useEffect, useState } from "react";
import api from "../api";

export default function SmsSettings() {
  const [cfg, setCfg] = useState(null);
  const [authKey, setAuthKey] = useState("");
  const [authSecret, setAuthSecret] = useState("");
  const [sender, setSender] = useState("");
  const [credit, setCredit] = useState(null);
  const [to, setTo] = useState("");
  const [text, setText] = useState("");
  const [sandbox, setSandbox] = useState(true);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const [waNumbers, setWaNumbers] = useState([]);
  const [waTo, setWaTo] = useState("");
  const [waText, setWaText] = useState("");
  const [waPhoneId, setWaPhoneId] = useState("");
  const [waFallback, setWaFallback] = useState(false);
  const [waSandbox, setWaSandbox] = useState(false);
  const [waMsg, setWaMsg] = useState("");
  const [waBusy, setWaBusy] = useState(false);

  const [waTemplates, setWaTemplates] = useState([]);
  const [waTplName, setWaTplName] = useState("");
  const [waTplLang, setWaTplLang] = useState("it");
  const [waTplParams, setWaTplParams] = useState("");
  const [waTplTo, setWaTplTo] = useState("");
  const [waTplBusy, setWaTplBusy] = useState(false);
  const [waTplMsg, setWaTplMsg] = useState("");

  const load = () => api.get("/sms/config").then((r) => { setCfg(r.data); setAuthKey(r.data.auth_key || ""); setSender(r.data.sender || ""); }).catch(() => {});
  const loadCredit = () => api.get("/sms/credit").then((r) => setCredit(r.data)).catch(() => setCredit(null));
  const loadWaNumbers = () => api.get("/sms/wa/numbers").then((r) => {
    setWaNumbers(r.data || []);
    if ((r.data || []).length && !waPhoneId) setWaPhoneId(String(r.data[0].id));
  }).catch(() => setWaNumbers([]));
  const loadWaTemplates = () => api.get("/sms/wa/templates").then((r) => setWaTemplates(r.data || [])).catch(() => setWaTemplates([]));
  useEffect(() => { load(); loadCredit(); loadWaNumbers(); loadWaTemplates(); }, []);

  const syncTemplates = async () => {
    setWaTplBusy(true); setWaTplMsg("");
    try {
      const r = await api.post("/sms/wa/templates/sync");
      setWaTemplates(r.data.templates || []);
      setWaTplMsg(`Sincronizzati ${(r.data.templates || []).length} template da WhatsApp Business.`);
    } catch (e) { setWaTplMsg("Errore sync: " + (e.response?.data?.detail || e.message)); }
    finally { setWaTplBusy(false); }
  };

  const pickTemplate = (name) => {
    setWaTplName(name);
    const t = waTemplates.find((x) => (x.name || x.elementName) === name);
    if (t && (t.language || t.languageCode)) setWaTplLang(t.language || t.languageCode);
  };

  const sendTemplate = async () => {
    if (!waTplTo.trim() || !waTplName) { setWaTplMsg("Scegli un template e indica il numero."); return; }
    setWaTplBusy(true); setWaTplMsg("");
    try {
      const body_params = waTplParams.split("|").map((s) => s.trim()).filter(Boolean);
      const r = await api.post("/sms/wa/send-template", {
        to: waTplTo, template_name: waTplName, language: waTplLang,
        body_params, phone_number_id: waPhoneId, fallback_sms: false, sandbox: waSandbox,
      });
      const wa = (r.data.wa || [])[0] || {};
      setWaTplMsg(`Esito: ${wa.status || JSON.stringify(r.data).slice(0, 120)}`);
    } catch (e) { setWaTplMsg("Errore invio: " + (e.response?.data?.detail || e.message)); }
    finally { setWaTplBusy(false); }
  };

  const save = async () => {
    setBusy(true); setMsg("");
    try {
      const body = { auth_key: authKey, sender };
      if (authSecret.trim()) body.auth_secret = authSecret.trim();
      await api.put("/sms/config", body);
      setAuthSecret(""); setMsg("Configurazione salvata."); load(); loadCredit();
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  const sendTest = async () => {
    if (!to.trim() || !text.trim()) { setMsg("Inserisci numero e testo."); return; }
    setBusy(true); setMsg("");
    try {
      const r = await api.post("/sms/send", { to, text, sandbox });
      setMsg(`Inviato (transactionId ${r.data.transactionId}, SMS inseriti: ${r.data.smsInserted}).`);
    } catch (e) { setMsg("Errore invio: " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  const sendWhatsApp = async () => {
    if (!waTo.trim() || !waText.trim()) { setWaMsg("Inserisci numero e testo."); return; }
    setWaBusy(true); setWaMsg("");
    try {
      const r = await api.post("/sms/wa/send", {
        to: waTo, text: waText, phone_number_id: waPhoneId,
        fallback_sms: waFallback, text_sms: waText, sandbox: waSandbox,
      });
      const wa = (r.data.wa || [])[0] || {};
      if (wa.status === "INSERTED") setWaMsg(`WhatsApp inviato a ${wa.to} (id ${wa.id}, transactionId ${r.data.transactionId}).`);
      else setWaMsg(`Esito: ${wa.status || "?"} ${wa.statusDetail ? "(" + wa.statusDetail + ")" : ""}. Inseriti: ${r.data.countInserted}, non inseriti: ${r.data.countNotInserted}.`);
    } catch (e) { setWaMsg("Errore invio: " + (e.response?.data?.detail || e.message)); }
    finally { setWaBusy(false); }
  };

  return (
    <div>
      <div className="panel">
        <h3>SMShosting</h3>
        <p className="muted">Invio SMS (e in futuro WhatsApp) tramite il tuo account SMShosting. Le chiavi sono salvate in modo cifrato.</p>
        {credit && (
          <div className="tag-filter" style={{ marginBottom: 10 }} data-testid="sms-credit">
            <span className="chip" style={{ background: "#16a34a" }}>Credito € {credit.credit}</span>
            <span className="chip" style={{ background: "#2563eb" }}>SMS Italia: {credit.italysms}</span>
            <span className="chip" style={{ background: "#7c3aed" }}>Email disponibili: {credit.emailAvailable}</span>
            <span className="chip" style={{ background: "#64748b" }}>Mittenti: {(credit.senderAlias || []).join(", ") || "—"}</span>
          </div>
        )}
        <div className="grid-2">
          <div className="field"><label>AUTH KEY</label>
            <input value={authKey} onChange={(e) => setAuthKey(e.target.value)} data-testid="sms-auth-key" />
          </div>
          <div className="field"><label>AUTH SECRET {cfg?.auth_secret_set && <span className="muted">(impostato: {cfg.auth_secret_preview})</span>}</label>
            <input type="password" value={authSecret} onChange={(e) => setAuthSecret(e.target.value)} placeholder={cfg?.auth_secret_set ? "•••• (lascia vuoto per non cambiare)" : ""} data-testid="sms-auth-secret" />
          </div>
        </div>
        <div className="field"><label>Mittente (alias registrato o numero)</label>
          <input value={sender} onChange={(e) => setSender(e.target.value)} data-testid="sms-sender" />
          <p className="muted" style={{ fontSize: 12 }}>Deve essere un mittente registrato su SMShosting. Per usare un alias testuale (es. "SC Studio") va prima richiesto e approvato nel pannello SMShosting.</p>
        </div>
        <button className="btn primary" onClick={save} disabled={busy} data-testid="sms-save-btn">Salva configurazione</button>
      </div>

      <div className="panel" style={{ marginTop: 18 }}>
        <h3>Invio SMS di prova</h3>
        <div className="field"><label>Numero destinatario (formato internazionale, es. +393331112233)</label>
          <input value={to} onChange={(e) => setTo(e.target.value)} placeholder="+39..." data-testid="sms-test-to" />
        </div>
        <div className="field"><label>Testo</label>
          <textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} data-testid="sms-test-text" />
        </div>
        <label className="muted" style={{ display: "flex", gap: 8, alignItems: "center", margin: "6px 0" }}>
          <input type="checkbox" checked={sandbox} onChange={(e) => setSandbox(e.target.checked)} data-testid="sms-sandbox" /> Modalità test (sandbox: non invia davvero, non consuma credito)
        </label>
        <button className="btn" onClick={sendTest} disabled={busy} data-testid="sms-send-btn">Invia SMS</button>
      </div>

      <div className="panel" style={{ marginTop: 18 }} data-testid="whatsapp-panel">
        <h3>WhatsApp Business</h3>
        <p className="muted">Invio messaggi WhatsApp tramite SMShosting. Con fallback SMS automatico se il messaggio WhatsApp non viene consegnato.</p>
        {waNumbers.length > 0 ? (
          <div className="tag-filter" style={{ marginBottom: 10 }} data-testid="wa-numbers">
            {waNumbers.map((n) => (
              <span key={n.id} className="chip" style={{ background: n.status === "APPROVED" ? "#16a34a" : "#64748b" }}>
                {n.description || n.phoneNumber} · {n.phoneNumber} · {n.status}
              </span>
            ))}
          </div>
        ) : (
          <p className="muted" data-testid="wa-no-numbers" style={{ color: "#b45309" }}>Nessun numero WhatsApp Business trovato sull'account.</p>
        )}
        {waNumbers.length > 1 && (
          <div className="field"><label>Numero mittente</label>
            <select value={waPhoneId} onChange={(e) => setWaPhoneId(e.target.value)} data-testid="wa-phone-select">
              {waNumbers.map((n) => <option key={n.id} value={n.id}>{n.description || n.phoneNumber} ({n.phoneNumber})</option>)}
            </select>
          </div>
        )}
        <div className="field"><label>Numero destinatario (formato internazionale, es. 393331112233)</label>
          <input value={waTo} onChange={(e) => setWaTo(e.target.value)} placeholder="39..." data-testid="wa-to" />
        </div>
        <div className="field"><label>Testo messaggio</label>
          <textarea rows={3} value={waText} onChange={(e) => setWaText(e.target.value)} data-testid="wa-text" />
        </div>
        <label className="muted" style={{ display: "flex", gap: 8, alignItems: "center", margin: "6px 0" }}>
          <input type="checkbox" checked={waFallback} onChange={(e) => setWaFallback(e.target.checked)} data-testid="wa-fallback" /> Fallback SMS se WhatsApp non consegnato
        </label>
        <label className="muted" style={{ display: "flex", gap: 8, alignItems: "center", margin: "6px 0" }}>
          <input type="checkbox" checked={waSandbox} onChange={(e) => setWaSandbox(e.target.checked)} data-testid="wa-sandbox" /> Modalità test (sandbox: non invia davvero)
        </label>
        <button className="btn" onClick={sendWhatsApp} disabled={waBusy} data-testid="wa-send-btn">Invia WhatsApp</button>
        {waMsg && <p className="muted" data-testid="wa-msg" style={{ marginTop: 10 }}>{waMsg}</p>}
      </div>

      <div className="panel" style={{ marginTop: 18 }} data-testid="wa-templates-panel">
        <div className="toolbar">
          <h3 style={{ margin: 0 }}>Template WhatsApp Business</h3>
          <div className="spacer" />
          <button className="btn sm" onClick={syncTemplates} disabled={waTplBusy} data-testid="wa-templates-sync">{waTplBusy ? "Sincronizzo…" : "↻ Sincronizza da Meta"}</button>
        </div>
        <p className="muted">I template approvati su WhatsApp Business Manager (Meta) servono per i messaggi <strong>fuori dalla finestra di 24h</strong> (business-initiated). Sincronizzali, poi inviali compilando i parametri.</p>
        {waTemplates.length > 0 ? (
          <table data-testid="wa-templates-table">
            <thead><tr><th>Nome</th><th>Lingua</th><th>Categoria</th><th>Stato</th></tr></thead>
            <tbody>
              {waTemplates.map((t) => (
                <tr key={t.id || t.name || t.elementName} data-testid={`wa-template-row-${t.name || t.elementName}`}>
                  <td>{t.name || t.elementName || "—"}</td>
                  <td className="muted">{t.language || t.languageCode || "—"}</td>
                  <td className="muted">{t.category || "—"}</td>
                  <td><span className="chip" style={{ background: (t.status === "APPROVED") ? "#16a34a" : "#64748b" }}>{t.status || "—"}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="muted" data-testid="wa-no-templates" style={{ color: "#b45309" }}>Nessun template trovato. Crea i template in WhatsApp Business Manager e premi "Sincronizza".</p>
        )}

        <div style={{ marginTop: 14, borderTop: "1px solid rgba(255,255,255,.08)", paddingTop: 14 }}>
          <h4 style={{ margin: "0 0 10px" }}>Invia un template</h4>
          <div className="field"><label>Template</label>
            <select value={waTplName} onChange={(e) => pickTemplate(e.target.value)} data-testid="wa-template-select">
              <option value="">— scegli un template —</option>
              {waTemplates.map((t) => <option key={t.id || t.name || t.elementName} value={t.name || t.elementName}>{t.name || t.elementName} ({t.language || t.languageCode || "?"})</option>)}
            </select>
          </div>
          <div className="grid-2">
            <div className="field"><label>Numero destinatario (es. 393331112233)</label>
              <input value={waTplTo} onChange={(e) => setWaTplTo(e.target.value)} placeholder="39..." data-testid="wa-template-to" />
            </div>
            <div className="field"><label>Lingua</label>
              <input value={waTplLang} onChange={(e) => setWaTplLang(e.target.value)} data-testid="wa-template-lang" />
            </div>
          </div>
          <div className="field"><label>Parametri del corpo (separati da | nell'ordine {"{{1}}, {{2}}…"})</label>
            <input value={waTplParams} onChange={(e) => setWaTplParams(e.target.value)} placeholder="Mario Rossi | 1.250,00 € | 16/07/2026" data-testid="wa-template-params" />
          </div>
          <label className="muted" style={{ display: "flex", gap: 8, alignItems: "center", margin: "6px 0" }}>
            <input type="checkbox" checked={waSandbox} onChange={(e) => setWaSandbox(e.target.checked)} data-testid="wa-template-sandbox" /> Modalità test (sandbox)
          </label>
          <button className="btn" onClick={sendTemplate} disabled={waTplBusy} data-testid="wa-template-send">Invia template</button>
          {waTplMsg && <p className="muted" data-testid="wa-template-msg" style={{ marginTop: 10 }}>{waTplMsg}</p>}
        </div>
      </div>
      {msg && <p className="muted" data-testid="sms-msg" style={{ marginTop: 10 }}>{msg}</p>}
    </div>
  );
}
